import { SelectValue } from '../schema/interface';

// reducer
export const SET_FIELD = 'SET_FIELD';
export const SET_FIELDS = 'SET_FIELDS';
const reducer = (state: { formValues: { [key: string]: string | SelectValue } }, action) => {
    switch (action.type) {
        case SET_FIELD:
            return {
                ...state,
                formValues: { ...state.formValues, [action.name]: action.value }
            };
        case SET_FIELDS:
            return { ...state, formValues: action.payload };

        default:
            return state;
    }
};
export default reducer;
